import { render, staticRenderFns } from "./UserAddAction.vue?vue&type=template&id=0a1cd764"
import script from "./UserAddAction.vue?vue&type=script&lang=js"
export * from "./UserAddAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports